import React, { useEffect, useRef, useState } from "react";
import moment, { Moment } from "moment";
import { Spinner } from "react-bootstrap";
import { useAuth } from "../../../../firebase/AuthProvider";
import { AllEvent, UpcommingMeetingDto } from "../../../../interfaces/identity/calendar/Events";
import { formatMeetingTime, getUpcomingMeetingsByDate, endMeeting } from "../../../../services/userServices/UserInfoService";
import { useNavigate } from "react-router-dom";
import { GoChevronRight } from "react-icons/go";
import Time from "../../../../assets/images/TIMEICON.svg";
import ModalMeet from "../../calendar/ModalMeet";
import AddEvent from "../../calendar/events/AddEvent";
import ViewEvent from "../../calendar/events/ViewEvent";
import { toast } from "react-toastify";



const UpcomingMeetingsOwner: React.FC = () => {
    const { currentUser } = useAuth();
    const today = moment();
    const navigate = useNavigate();
    const Right = GoChevronRight as any;
    const scrollRef = useRef<HTMLDivElement | null>(null);

    const [selectedDate, setSelectedDate] = useState<Moment>(today);
    const [loading, setLoading] = useState<boolean>(false);
    const [isAddEvent, setIsAddEvent] = useState<boolean>(false);
    //data
    const [allUpcomingMeetings, setAllUpcomingMeetings] = useState<UpcommingMeetingDto[]>([]);
    const [clickedSlotMoment, setClickedSlotMoment] = useState<moment.Moment | null>(null);
    const [selectedViewEvent, setSelectedViewEvent] = useState<AllEvent | null>(null);
    const [isViewEventOpen, setIsViewEventOpen] = useState(false);

    const isToday = selectedDate.isSame(moment(), "day");

    // Generate dates for today + next 6 days
    const dates = Array.from({ length: 7 }, (_, i) =>
        moment().add(i, "days")
    );

    const handleEndMeeting = async (meetingId: string) => {
        try {
            if (!currentUser) return;

            const token = await currentUser.getIdToken();

            // Call the endMeeting API
            const result = await endMeeting(meetingId.toString(), token, "single");

            if (result.success) {
                console.log("Meeting ended successfully");
                toast.success("Meeting ended successfully");
                // Refresh list
                fetchAllUpcomingMeetings(
                    [currentUser.uid],
                    selectedDate.toDate()
                );
            } else {
                console.error("Failed to end meeting:", result.message);
                toast.error(result.message);
            }
        } catch (err) {
            console.error("Failed to end meeting", err);
            toast.error("Failed to end meeting");
        }
    };


    const roundDownTo30Minutes = (m: moment.Moment) => {
        const minutes = m.minutes();
        const roundedMinutes = minutes < 30 ? 0 : 30;
        return m.clone().minutes(roundedMinutes).seconds(0).milliseconds(0);
    };

    const mapUpcomingMeetingToAllEvent = (
        meeting: UpcommingMeetingDto
    ): AllEvent => {
        return {
            id: meeting.id,
            title: meeting.title,
            startTime: meeting.startTime,
            endTime: meeting.endTime,
            description: meeting.description || "",
            location: meeting.location || "",
            meetingDetails: meeting.meetingDetails || "",
            ownerUserID: meeting.ownerUserID,
            ownerName: meeting.ownerName,
            ownerColor: meeting.ownerColor,

            // 🔥 MOST IMPORTANT FIX
            participantUserIds: meeting.participantUsers
                ? meeting.participantUsers.map(p => p.participantId)
                : [],

            externalUserEmails: meeting.externalUserEmails || [],

            taskId: 0,
            taskTitle: "",
            online: meeting.online ?? true,
            isSprout: meeting.isSprout ?? false,
            isInvitationAccept: meeting.isInvitationAccept ?? null,

            recurrenceRule: undefined,
            parentEventId: undefined,
            time_zone: undefined,
        };
    };


    // on Chnage the date data will fetch
    useEffect(() => {
        if (selectedDate) {
            if (!currentUser?.uid) return;
            fetchAllUpcomingMeetings([currentUser.uid], selectedDate.toDate()); // <-- use selectedDate
        }
    }, [selectedDate, currentUser]);


    // const fetchAllUpcomingMeetings = async (userIds: string[], date: Date) => {
    //     setLoading(true);
    //     setAllUpcomingMeetings([]);

    //     try {
    //         if (!currentUser) return;

    //         const token = await currentUser.getIdToken();

    //         let startMoment = moment(date);

    //         // ✅ If today → start from current time
    //         if (startMoment.isSame(moment(), "day")) {
    //             startMoment = moment();
    //         } else {
    //             // Other days → start from beginning of day
    //             startMoment = startMoment.startOf("day");
    //         }

    //         const meetingResult = await getUpcomingMeetingsByDate(
    //             userIds[0],
    //             token,
    //             startMoment.utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
    //         );

    //         if (meetingResult.success) {
    //             setAllUpcomingMeetings(meetingResult.data);
    //         }
    //     } catch (error) {
    //         console.error("Failed to load meetings:", error);
    //         setAllUpcomingMeetings([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const fetchAllUpcomingMeetings = async (userIds: string[], date: Date) => {
        setLoading(true);
        setAllUpcomingMeetings([]);

        try {
            if (!currentUser) return;

            const token = await currentUser.getIdToken();

            const startMoment = moment(date).startOf("day"); // ✅ SAME FOR ALL DAYS

            const meetingResult = await getUpcomingMeetingsByDate(
                userIds[0],
                token,
                startMoment.utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            );

            if (meetingResult.success) {
                setAllUpcomingMeetings(meetingResult.data);
            }
        } finally {
            setLoading(false);
        }
    };

    // const NOW = moment();
    // const THREE_HOURS_LATER = moment().add(3, "hours");

    const formatTime = (dateStr: string) => {
        return moment.utc(dateStr).local().format('hh:mm A');
    };

    // const visibleMeetings = allUpcomingMeetings.filter(meeting => {
    //     if (!isToday) return true;

    //     // const start = moment.utc(meeting.startTime).local();
    //     // return start.isBetween(NOW, THREE_HOURS_LATER, undefined, "[)");
    //     const start = moment.utc(meeting.startTime).local();
    //     return start.isSameOrAfter(moment());
    // });

    const visibleMeetings = allUpcomingMeetings;

    const getInitials = (name: string) => {
        if (!name) return "?";

        const clean = name.trim().replace(/\s+/g, " ");
        const words = clean.split(" ");

        if (words.length === 1) {
            return clean.charAt(0).toUpperCase();
        }

        return (words[0][0] + words[1][0]).toUpperCase();
    };

    const handleGridClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const gridTop = e.currentTarget.getBoundingClientRect().top;
        const clickY = e.clientY - gridTop;

        const slotIndex = Math.floor(clickY / SLOT_HEIGHT);
        const minutesFromStart = slotIndex * 30;

        const slotMoment = gridStartMoment().clone().add(minutesFromStart, "minutes");

        // Prevent past time clicks (today only)
        if (isToday && slotMoment.isBefore(moment())) return;

        setClickedSlotMoment(slotMoment);
        setIsAddEvent(true);
    };


    const colors = [
        "bg-red-500",
        "bg-green-500",
        "bg-blue-500",
        "bg-purple-500",
        "bg-yellow-500",
        "bg-pink-500",
        "bg-indigo-500",
    ];

    const getColor = (name: string) =>
        colors[name.charCodeAt(0) % colors.length];


    const Avatar = ({ name }: { name: string }) => {
        const [show, setShow] = React.useState(false);

        return (
            <div
                className="relative"
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
            >
                <div
                    className={`h-8 w-8 rounded-full border-2 border-white 
                ${getColor(name)} flex items-center justify-center 
                text-[12px] font-semibold text-white select-none`}
                >
                    {getInitials(name)}
                </div>

                {show && (
                    <div
                        className="absolute z-50 -top-9 left-1/2 
                    -translate-x-1/2 whitespace-nowrap rounded-md 
                    bg-white px-2 py-1 text-xs text-black 
                    shadow-lg max-w-[120px] truncate"
                    >
                        {name}
                    </div>
                )}
            </div>
        );
    };

    // const gridStartMoment = () => {
    //     return isToday
    //         ? moment().startOf("minute")
    //         : moment(selectedDate).startOf("day");
    // };

    // const gridStartMoment = () => {
    //     if (isToday) {
    //         return roundDownTo30Minutes(moment());
    //     }
    //     return moment(selectedDate).startOf("day");
    // };
    const gridStartMoment = () => {
        if (isToday) {
            return roundDownTo30Minutes(moment());
        }
        return moment(selectedDate).startOf("day");
    };


    const minutesFromGridStart = (dateStr: string) => {
        const m = moment.utc(dateStr).local();
        return m.diff(gridStartMoment(), "minutes");
    };

    const getTopPosition = (startTime: string) => {
        const minutes = minutesFromGridStart(startTime);
        return (minutes / 60) * SLOT_HEIGHT;
    };

    const getHeight = (startTime: string, endTime: string) => {
        const start = minutesFromGridStart(startTime);
        const end = minutesFromGridStart(endTime);
        return ((end - start) / 60) * SLOT_HEIGHT;
    };


    const getTimeLeft = (startTime: string) => {
        const now = moment();
        const start = moment.utc(startTime).local();

        const diffMinutes = start.diff(now, "minutes");

        if (diffMinutes <= 0) return "Started";

        const days = Math.floor(diffMinutes / (60 * 24));
        const hours = Math.floor((diffMinutes % (60 * 24)) / 60);

        if (days > 0) return `${days}d left`;
        if (hours > 0) return `${hours}h left`;

        return `${diffMinutes}m left`;
    };

    // const generateTimeGrid = () => {
    //     const times: string[] = [];

    //     let start = isToday
    //         ? roundDownTo30Minutes(moment())
    //         : moment(selectedDate).startOf("day");

    //     // let end = isToday
    //     //     ? moment().add(3, "hours")
    //     //     : moment(selectedDate).endOf("day");

    //     let end = moment(selectedDate).endOf("day"); // ✅ FULL DAY FOR ALL

    //     while (start.isBefore(end)) {
    //         times.push(start.format("hh:mm A"));
    //         start = start.add(1, "hour");
    //     }

    //     return times;
    // };

    const generateTimeGrid = () => {
        const times: string[] = [];

        let start = moment(selectedDate).startOf("day");
        let end = moment(selectedDate).endOf("day");

        while (start.isBefore(end)) {
            times.push(start.format("hh:mm A"));
            start = start.add(1, "hour");
        }

        return times;
    };

    const SLOT_HEIGHT = 80; // 30 minutes = 80px

    const minutesFromStartOfDay = (dateStr: string) => {
        const m = moment.utc(dateStr).local();
        return m.hours() * 60 + m.minutes();
    };

    const groupedMeetings: Record<string, UpcommingMeetingDto[]> =
        visibleMeetings.reduce((acc, meeting) => {
            const key = moment.utc(meeting.startTime).local().format("HH:mm");
            if (!acc[key]) acc[key] = [];
            acc[key].push(meeting);
            return acc;
        }, {} as Record<string, UpcommingMeetingDto[]>);




    useEffect(() => {
        if (!scrollRef.current || allUpcomingMeetings.length === 0) return;

        // Find earliest meeting
        const earliestMeeting = allUpcomingMeetings.reduce((earliest, current) =>
            moment.utc(current.startTime).isBefore(moment.utc(earliest.startTime))
                ? current
                : earliest
        );

        const top = getTopPosition(earliestMeeting.startTime);

        // Small offset so meeting is not glued to top
        scrollRef.current.scrollTo({
            top: Math.max(top - 40, 0),
            behavior: "smooth",
        });
    }, [allUpcomingMeetings]);

    useEffect(() => {
        if (!scrollRef.current) return;

        if (isToday) {
            scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [selectedDate]);

    return (
        <>
            <div className="ow_nw_box min-h-full" style={{ paddingBottom: "0px" }}>
                {/* Header */}
                <div className="ow_nw_header_row">
                    <h3 className="text-[16px] xl:text-[18px] 2xl:text-[20px] font-semibold">Upcoming Meetings</h3>
                    <span onClick={() => navigate("/calendar")} className="text-[14px] font-semibold text-[#7E57C2] whitespace-nowrap flex items-center cursor-pointer">
                        View all <span className="text-[20px] mb-[1px]"><Right /></span>
                    </span>
                </div>

                {/* Month */}
                <div className="text-[16px] mb-2.5 font-medium">
                    {selectedDate.format("MMMM YYYY")}
                </div>

                <div className="flex gap-2">
                    {dates.map((date) => {
                        const isSelected = date.isSame(selectedDate, "day");

                        return (
                            <div
                                key={date.format("YYYY-MM-DD")}
                                onClick={() => setSelectedDate(date)}
                                role="button"
                                tabIndex={0}
                                className={`w-full h-[80px] rounded-[8px] border flex flex-col items-center justify-center cursor-pointer font-[Poppins] transition-all ${isSelected ? "bg-[#EF905D] border-[#EF905D]" :
                                    "bg-white border-[#747474]"}`}>
                                {isSelected ? (
                                    <>
                                        <span
                                            className={`text-sm xl:!text-[16px] font-medium leading-[18px] 
                                ${isSelected ? "text-black" : "text-[#000000]"}`}
                                        >
                                            {date.format("DD")}
                                        </span>
                                        <span
                                            className={`mt-1 text-sm xl:!text-[16px] leading-[18px] font-medium uppercase
                                ${isSelected ? "text-black" : "text-[#000000]"}`}
                                        >
                                            {date.format("ddd")}
                                        </span>
                                    </>
                                ) : (
                                    <span
                                        className="text-sm xl:!text-[16px] leading-[18px] font-medium uppercase text-[#747474] text-center"
                                    >
                                        <p className="m-0">{date.format("DD")}</p>
                                        <p className="m-0 pt-[2px]">{date.format("ddd")}</p>
                                    </span>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div ref={scrollRef} className="h-[320px] overflow-auto mt-3 no-scrollbar">
                    {loading ? (
                        <div className="relative flex animate-pulse">
                            <div className="flex-1 space-y-4">
                                {[...Array(2)].map((_, i) => (
                                    <div
                                        key={i}
                                        className="relative bg-gray-100 rounded-[8px] p-4 space-y-3"
                                    >
                                        {/* Title */}
                                        <div className="h-4 w-2/3 bg-gray-300 rounded" />

                                        {/* Time */}
                                        <div className="h-3 w-1/3 bg-gray-200 rounded" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="relative flex cursor-pointer" onClick={handleGridClick}>
                            {/* Background grid */}
                            <div className="absolute inset-0 z-0 pointer-events-none">
                                {generateTimeGrid().map((_, index) => (
                                    <React.Fragment key={index}>
                                        {/* Hour line */}
                                        <div
                                            className="absolute left-[60px] right-0 h-[1px] bg-[#EDEDED]"
                                            style={{ top: index * 80 }}
                                        />

                                        {/* Half-hour line */}
                                        <div
                                            className="absolute left-[60px] right-0 h-[1px] bg-[#EDEDED]"
                                            style={{ top: index * 80 + 40 }}
                                        />
                                    </React.Fragment>
                                ))}
                            </div>

                            {/* Time labels */}
                            <div className="min-w-fit z-10">
                                {generateTimeGrid().map(time => (
                                    <div
                                        key={time}
                                        className="h-[80px] text-right text-xs flex items-start"
                                    >
                                        {time}
                                    </div>
                                ))}
                            </div>

                            {/* Events */}
                            <div className="flex-1 pl-4 space-y-3 z-10">
                                {loading ? (
                                    <div className="p-3 flex justify-center">
                                        <Spinner size="sm" />
                                    </div>
                                ) : (
                                    Object.entries(groupedMeetings).flatMap(
                                        ([_, meetings]: [string, UpcommingMeetingDto[]]) =>
                                            meetings.map((meeting, index) => {
                                                const top = getTopPosition(meeting.startTime);
                                                const height = getHeight(meeting.startTime, meeting.endTime);
                                                const meetTime = moment.utc(meeting.startTime).local();
                                                const timeStr = formatMeetingTime(meetTime.toDate());


                                                // const isOngoing =
                                                //     moment().isAfter(moment.utc(meeting.startTime).local()) &&
                                                //     moment().isBefore(moment.utc(meeting.endTime).local());


                                                const isOngoing = true; // Temporarily always true for testing

                                                const timeLeft = getTimeLeft(meeting.startTime);
                                                return (
                                                    <div
                                                        key={meeting.id}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const convertedEvent = mapUpcomingMeetingToAllEvent(meeting);
                                                            setSelectedViewEvent(convertedEvent);
                                                            setIsViewEventOpen(true);
                                                        }}
                                                        className="absolute cursor-pointer hover:!bg-[#e6e6e6] left-[80px] h-fit right-4 rounded-[8px] pl-4 pr-1 xl:pr-2 py-1.5 xl:py-3"
                                                        // className={`relative ${meeting?.isInvitationAccept ? "bg-[#F4F4F4]" : "bg-transparent"}  rounded-[8px] pl-4 pr-2 py-3 gap-3`}
                                                        style={{
                                                            top: top + index * 10,
                                                            // height,
                                                            backgroundColor: meeting.isInvitationAccept
                                                                ? "#F4F4F4"
                                                                : "transparent",
                                                            border: meeting.isInvitationAccept
                                                                ? "none"
                                                                : "1px dashed #747474",
                                                        }}
                                                    >
                                                        {
                                                            meeting?.isInvitationAccept &&
                                                            <span
                                                                className="absolute left-0 top-0 h-full w-[5px] rounded-l-[8px]"
                                                                style={{
                                                                    backgroundColor:
                                                                        meeting.ownerColor && meeting.ownerColor !== "#66E046"
                                                                            ? meeting.ownerColor
                                                                            : "#66E046", // fallback
                                                                }}
                                                            />

                                                        }
                                                        {/* 
                                                        <div className="flex justify-between flex-wrap gap-1.5 capitalize" style={{ alignItems: "start" }}>
                                                            <span className="text-[11px] xl:text-[14px] font-medium text-black leading-[20px]">
                                                                {meeting.title.length > 20
                                                                    ? meeting.title.slice(0, 20) + "..."
                                                                    : meeting.title}
                                                            </span>

                                                            <span className={`text-[9px] xl:text-[12px] font-medium ${meeting?.isInvitationAccept ? "text-[#7E57C2]" : "text-black"}  whitespace-nowrap flex items-center gap-1`}>
                                                                {formatTime(meeting.startTime)} – {formatTime(meeting.endTime)}
                                                                <span className="text-[14px] xl:text-[18px]"><Right /></span>
                                                            </span>
                                                        </div> */}

                                                        <div className="flex justify-between items-center flex-wrap gap-2">
                                                            <span className="text-[11px] xl:text-[14px] font-medium text-black">
                                                                {meeting.title.length > 20
                                                                    ? meeting.title.slice(0, 20) + "..."
                                                                    : meeting.title}
                                                            </span>

                                                            <div className="flex items-center gap-2">
                                                                <span className="text-[9px] xl:text-[12px] font-medium whitespace-nowrap flex items-center gap-1">
                                                                    {formatTime(meeting.startTime)} – {formatTime(meeting.endTime)}
                                                                    <Right />
                                                                </span>

                                                                {/* END MEETING BUTTON */}
                                                                {isOngoing && (
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleEndMeeting(meeting.id);
                                                                        }}
                                                                        className="text-[10px] xl:text-[12px] px-2 py-1 
                                                                            rounded-md bg-red-500 text-white 
                                                                            hover:bg-red-600 transition"
                                                                    >
                                                                        End
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {
                                                            meeting?.isInvitationAccept &&
                                                            <div className="flex items-center gap-3 flex-wrap mt-2.5">
                                                                <div className="flex items-center ">
                                                                    {/* Avatars */}
                                                                    <div className="flex -space-x-2">
                                                                        {meeting.participantUsers.slice(0, 3).map((p) => (
                                                                            <Avatar
                                                                                key={p.participantId}
                                                                                name={p.participantName || p.participantId}
                                                                            />
                                                                        ))}

                                                                        {/* +N indicator */}
                                                                        {meeting.participantUsers.length > 3 && (
                                                                            <div
                                                                                className="h-8 w-8 rounded-full border-2 border-white 
                                   bg-gray-300 flex items-center justify-center 
                                   text-xs font-semibold text-gray-700"
                                                                            >
                                                                                +{meeting.participantUsers.length - 3}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* Attendees text */}
                                                                    <span
                                                                        className={`${meeting.participantUsers.length > 0 ? "ml-3" : "ml-0"
                                                                            } text-[#4A5565] text-[11px] xl:text-[14px]`}
                                                                    >
                                                                        {meeting.participantUsers.length}{" "}
                                                                        {meeting.participantUsers.length === 1 ? "Attendee" : "Attendees"}
                                                                    </span>
                                                                </div>

                                                                {/* Meta text */}
                                                                <div className="flex items-center gap-2 text-[14px] text-[#6B6B6B]">
                                                                    <span className="flex items-center gap-2 text-[11px] xl:text-[14px]">
                                                                        <img
                                                                            style={{ width: "17px" }}
                                                                            src={Time}
                                                                            alt="Time"
                                                                        />
                                                                        {timeLeft}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                );
                                            })
                                    )
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {
                isAddEvent && (
                    <>
                        <ModalMeet isOpen={isAddEvent} onClose={() => setIsAddEvent(false)}>
                            <AddEvent
                                event={null}
                                clickedDateTime={clickedSlotMoment}
                                onClose={() => {
                                    setIsAddEvent(false);
                                    setClickedSlotMoment(null);
                                }}
                            />
                        </ModalMeet>
                    </>
                )
            }

            {isViewEventOpen && selectedViewEvent && (
                <ModalMeet
                    isOpen={isViewEventOpen}
                    onClose={() => {
                        setIsViewEventOpen(false);
                        setSelectedViewEvent(null);
                    }}
                    widthClass="max-w-[570px]"
                >
                    <ViewEvent
                        event={selectedViewEvent}
                        onClose={() => {
                            setIsViewEventOpen(false);
                            setSelectedViewEvent(null);
                        }}
                        refreshAllEvents={() =>
                            fetchAllUpcomingMeetings(
                                [currentUser!.uid],
                                selectedDate.toDate()
                            )
                        }
                    />
                </ModalMeet>
            )}



        </>
    );
};

export default UpcomingMeetingsOwner;
